module.exports = __webpack_public_path__ + "static/media/romi.ef3b4a47.png";